import React from 'react'
import { Link } from 'react-router-dom'

const PartnerSection = ({data}) => {
  console.log({data})
  return (
    <div className="lg:mb-24">
      <h2 className="lg:text-lg font-bold uppercase mb-5 lg:mb-10">Organization Partners</h2>
      <div className="flex flex-wrap -mx-2 lg:-mx-4">
        {
          data &&
          data.map((d, index) => {
            return (
              <div className="mb-5 w-1/2 lg:w-1/3 px-2 lg:px-4" key={index}>
                <Link to={`/organization/${d.id ? d.id : '1'}/detail`}>
                  {/* <SimpleCard data={d}/> */}
                  <div className="flex items-center">
                    <div
                      style={{minWidth: '36px', height: '36px', backgroundColor: '#efefef', backgroundBlendMode: 'multiply', backgroundImage: `url('${d.image}')`, backgroundSize: '70%'}}
                      className="rounded-full bg-no-repeat bg-center mr-3"
                    />
                    <div className="text-xs">
                      {d.name}
                    </div>
                  </div>
                </Link>
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

export { PartnerSection }
